__turbopack_context__.v({
  "blockTable": "p7rysG_blockTable",
  "column": "p7rysG_column",
  "contents": "p7rysG_contents",
  "contentsWrapper": "p7rysG_contentsWrapper",
  "fixed": "p7rysG_fixed",
  "full": "p7rysG_full",
  "hasTitle": "p7rysG_hasTitle",
  "outerContents": "p7rysG_outerContents",
  "scrollRightButton": "p7rysG_scrollRightButton",
  "titles": "p7rysG_titles",
});
